import styled, { css } from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import Menu from '@material-ui/core/Menu';

// CONSTANTS
import { GRAY_SUIT } from '@/constants/colors';

const rootStyles = css`
  .dialog-menu-actions {
    &__paper {
      border-radius: 4px;
    }

    &__dialog-content {
      padding: 4px 0px;
    }

    &__list {
      width: 100%;
    }

    &__list-item {
      padding: 13px 16px;
    }

    &__list-item-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 30px;
      font-size: 32px;
    }

    &__list-item-text {
      padding-left: 5px;
    }

    &__divider {
      margin: 0px 16px;
    }
  }
`;

export const DialogStyled = styled(Dialog)`
  ${rootStyles}

  .dialog-menu-actions {
    &__list-item-icon {
      color: ${GRAY_SUIT};
    }
  }
`;

export const MenuStyled = styled(Menu)`
  ${rootStyles}

  .dialog-menu-actions {
    &__list {
      padding: 0;
      width: 286px;
    }

    &__list-item {
      padding: 12px;
    }
  }
`;

export default DialogStyled;
